export const joints = [
  {
    jointNumber: 0,
    jointName: 'Joint 0',
  },
  {
    jointNumber: 1,
    jointName: 'Joint 1',
  },
  {
    jointNumber: 2,
    jointName: 'Joint 2',
  },
  {
    jointNumber: 3,
    jointName: 'Joint 3',
  },
  {
    jointNumber: 4,
    jointName: 'Joint 4',
  },
  {
    jointNumber: 5,
    jointName: 'Joint 5',
  },
  {
    jointNumber: 10,
    jointName: 'EE Board',
  },
  {
    jointNumber: 6,
    jointName: 'Safety Power Board',
  },
  {
    jointNumber: 13,
    jointName: 'Power Board',
  },
  {
    jointNumber: 12,
    jointName: 'IO Board',
  },
] as const;

export type JointNumber = (typeof joints)[number]['jointNumber'];

export const lookupJoint = (jointNumber: JointNumber) =>
  joints.find((joint) => joint.jointNumber === jointNumber);

// Customer bots have bootloader vulnerability to flashing wrong firmware to io causing a bricked Control Box
export function getAllJointsExceptIOboard() {
  return joints.filter((joint) => joint.jointName !== 'IO Board');
}

export const getAllJointNumbersExceptIOBoard = getAllJointsExceptIOboard().map(
  (joint) => joint.jointNumber,
);

/** Joint numbers for the control box boards (Safety Power, IO, Power). */
export const CONTROL_BOARD_JOINT_NUMBERS: readonly number[] = [6, 12, 13];

export const getFirmwareTypeByJointNumber = (jointNumber: number) => {
  switch (jointNumber) {
    case 0:
    case 1:
      return 'MotorBoardShoulder';
    case 2:
      return 'MotorBoardElbow';
    case 3:
    case 4:
    case 5:
      return 'MotorBoardWrist';
    case 6:
    case 13:
      return 'PowerBoard';
    case 12:
      return 'IOBoard';
    case 10:
      return 'EEBoard';
    default:
      return 'UNKNOWN';
  }
};
